// ─────────────────────────────────────────────────────────────────────────────
// products.js 
// ─────────────────────────────────────────────────────────────────────────────
import livervital from '../assets/images/products/Products/Miavit/Livervital L.jpg'
import miaclost from '../assets/images/products/Products/Miavit/MiaClost.jpg'
import miacalciumhighd from '../assets/images/products/Products/Miavit/M.png'
import miaroml from '../assets/images/products/Products/Miavit/Miarom Classic.jpg'
import ad3ec from '../assets/images/products/Products/Miavit/M.png'
import vitamineselenium from '../assets/images/products/Products/Miavit/M.png'
import amivit from '../assets/images/products/Products/Miavit/AmiVit_Gold.jpg'
import miacidl from '../assets/images/products/Products/Miavit/M.png'
import miaphos from '../assets/images/products/Products/Miavit/MiaPhos_poultry.jpg'
import vitaminc900p from '../assets/images/products/Products/Miavit/M.png'
import alllytec from '../assets/images/products/Products/Omeg_Pharma/All-lyteC.jpeg'
import miafirstaidp from '../assets/images/products/Products/Miavit/MiaFirstAid P.jpg'
import miaqlite from '../assets/images/products/Products/Miavit/MiaQlyte.jpg'
import miapower180 from '../assets/images/products/Products/Miavit/M.png'
import lipotexplus from '../assets/images/products/Products/Tex_biosciences/lipotexplus.png'
import miacowstartp from '../assets/images/products/Products/Miavit/M.png'
import texphytase from '../assets/images/products/Products/Tex_biosciences/texphytase.png'
import mineralpremix from '../assets/images/products/Products/Miavit/M.png'
import vitaminpremix from '../assets/images/products/Products/Miavit/M.png'
import metalac from '../assets/images/products/Products/STI_Biotechnologie/Metalac.jpeg'
import aviance from '../assets/images/products/Products/Techna_Feedia/Aviance.jpeg'

export const products = [

  // ── POULTRY - MIAVIT ─────────────────────────────────────────────────────

  {
    id:          'livervital',
    slug:        'livervital',
    name:        'Livervital',
    badge:       'Liver Health',
    category:    'liver-health',
    sectors:     ['Poultry'],
    supplier:    'miavit',
    packSize:    '1 L',
    featured:    true,
    flagship:    true,
    image:       livervital,
    tagline:     'Optimum liver health for high-performance poultry.',
    description: 'Livervital is a liver cell protectant formulated to support and maintain optimum liver health in poultry - particularly effective in cases of Inclusion Body Hepatitis (IBH) and Fatty Liver Syndrome. A healthy liver is essential for nutrient metabolism, immune function, and overall productivity.',
    benefits: [
      'Optimum liver health both in IBH and Fatty Liver conditions',
      'Protects liver cells from oxidative damage',
      'Supports nutrient metabolism and absorption',
      'Improves overall flock productivity',
      'Enhances immune function',
    ],
    usage: 'Via drinking water. Consult technical team for dosage specific to flock age and condition.',
  },

  {
    id:          'miaclost',
    slug:        'miaclost',
    name:        'MiaClost',
    badge:       'Gut Health',
    category:    'gut-health',
    sectors:     ['Poultry'],
    supplier:    'miavit',
    packSize:    '200 g',
    featured:    true,
    flagship:    true,
    image:       miaclost,
    tagline:     'Probiotic protection for a healthy gut.',
    description: 'MiaClost is a probiotic supplement designed to support gut health and microbial balance in poultry. By establishing beneficial gut flora, MiaClost helps prevent Clostridium-related intestinal disorders, improves feed conversion, and reduces the need for antibiotic intervention.',
    benefits: [
      'Probiotics for gut health',
      'Establishes and maintains healthy gut flora',
      'Prevents Clostridium-related gut disorders',
      'Improves feed conversion ratio',
      'Reduces dependency on antibiotics',
    ],
    usage: 'Mix in feed or drinking water as directed.',
  },

  {
    id:          'miarom-l',
    slug:        'miarom-l',
    name:        'Miarom L',
    badge:       'Respiratory Health',
    category:    'respiratory-health',
    sectors:     ['Poultry'],
    supplier:    'miavit',
    packSize:    '1 L',
    featured:    false,
    flagship:    false,
    image:       miaroml,
    tagline:     'Natural essential oil support for respiratory health.',
    description: 'MiaRom L is an essential oil-based liquid supplement formulated to support respiratory health in poultry. The blend of natural aromatic compounds helps open airways, reduce respiratory irritation, and supports the immune response during respiratory challenges.',
    benefits: [
      'Respiratory health support via essential oils',
      'Natural essential oil formulation',
      'Reduces respiratory irritation',
      'Supports immune response',
      'Improves air quality tolerance',
    ],
    usage: 'Via drinking water during respiratory health challenges.',
  },

  {
    id:          'amivit',
    slug:        'amivit',
    name:        'AmiVit',
    badge:       'Vitamin Supplement',
    category:    'vitamin-mineral-supplements',
    sectors:     ['Poultry'],
    supplier:    'miavit',
    packSize:    '5 L',
    featured:    false,
    flagship:    false,
    image:       amivit,
    tagline:     'The ideal start for chick development.',
    description: 'AmiVit is a vitamin supplement specifically designed to support the early development of day-old and young chicks. A strong nutritional start is critical for long-term performance - AmiVit provides the essential vitamins needed during this critical growth window.',
    benefits: [
      'Chick early development support',
      'Critical vitamins for day-old chicks',
      'Improves uniformity and growth rate',
      'Reduces early mortality',
      'Sets foundation for productive flock',
    ],
    usage: 'Via drinking water from day one. Follow recommended chick starter programme.',
  },

  {
    id:          'miaphos',
    slug:        'miaphos',
    name:        'MiaPhos',
    badge:       'Mineral Supplement',
    category:    'vitamin-mineral-supplements',
    sectors:     ['Poultry'],
    supplier:    'miavit',
    packSize:    '5 L',
    featured:    false,
    flagship:    false,
    image:       miaphos,
    tagline:     'Essential mineral supplementation via water.',
    description: 'MiaPhos is a water-soluble mineral supplement providing essential phosphorus and other key minerals for poultry. Adequate mineral supply is critical for bone development, eggshell formation, and metabolic function throughout all stages of production.',
    benefits: [
      'Mineral supplement for poultry',
      'Provides bioavailable phosphorus',
      'Supports bone and skeletal development',
      'Aids eggshell quality',
      'Easy water administration',
    ],
    usage: 'Via drinking water. Adjust dose based on flock age and production stage.',
  },

    // ── DAIRY - MIAVIT ────────────────────────────────────────────────────────

  {
    id:          'miafirstaid-p',
    slug:        'miafirstaid-p',
    name:        'MiaFirstAid P',
    badge:       'Gut Health',
    category:    'gut-health',
    sectors:     ['Dairy'],
    supplier:    'miavit',
    packSize:    '100 g',
    featured:    false,
    flagship:    false,
    image:       miafirstaidp,
    tagline:     'Fast-acting prebiotic protection against diarrhoea.',
    description: 'MiaFirstAid P is a prebiotic supplement for dairy calves designed to combat neonatal diarrhoea - one of the leading causes of calf mortality. It supports the establishment of healthy gut flora and helps firm loose stools during the critical early life period.',
    benefits: [
      'Anti-diarrhoea prebiotic for calves',
      'Establishes healthy gut flora',
      'Reduces early calf mortality',
      'Fast-acting prebiotic formula',
      'Critical support during first weeks of life',
    ],
    usage: 'Mix in milk replacer or warm water. Administer at first signs of diarrhoea.',
  },

  {
    id:          'miaqlite',
    slug:        'miaqlite',
    name:        'MiaQlyte',
    badge:       'Electrolyte',
    category:    'electrolytes',
    sectors:     ['Dairy'],
    supplier:    'miavit',
    packSize:    '1 L',
    featured:    false,
    flagship:    false,
    image:       miaqlite,
    tagline:     'Electrolyte recovery for diarrhoeic calves.',
    description: 'MiaQlyte is an electrolyte supplement specifically formulated for dairy calves suffering from diarrhoea. Diarrhoea causes rapid dehydration and electrolyte imbalance - MiaQlyte provides fast, effective rehydration to support recovery and reduce calf losses.',
    benefits: [
      'Electrolyte supplement for diarrhoeic calves',
      'Rapid rehydration for diarrhoeic calves',
      'Restores electrolyte balance',
      'Reduces calf mortality from scours',
      'Easy oral administration',
    ],
    usage: 'Dissolve in warm water. Administer orally to affected calves.',
  },

    // ── POULTRY & PIG - TECHNA FEEDIA ────────────────────────────────────────

  {
    id:          'aviance',
    slug:        'aviance',
    name:        'Aviance',
    badge:       'Feed Additive',
    category:    'feed-additives',
    sectors:     ['Poultry', 'Pig'],
    supplier:    'technafeedia',
    packSize:    '25 Kg',
    featured:    false,
    flagship:    false,
    image:       aviance,
    tagline:     'Natural growth promotion through feed.',
    description: 'Aviance is an essential oil-based feed additive that acts as a natural growth promoter for poultry and pigs. Formulated with precision by Techna Feedia, Aviance improves feed intake, supports gut integrity, and enhances growth performance without the use of antibiotic growth promoters.',
    benefits: [
      'Growth promoter feed additive',
      'Essential oil-based natural formulation',
      'Improves feed intake and conversion',
      'Supports gut integrity and health',
      'Antibiotic-free growth promotion',
    ],
    usage: 'Mix homogeneously into complete feed at recommended inclusion rate.',
  },

    // ── POULTRY & PIG - STI BIOTECHNOLOGIE ───────────────────────────────────

  {
    id:          'metalac',
    slug:        'metalac',
    name:        'Metalac',
    badge:       'Gut Health',
    category:    'gut-health',
    sectors:     ['Poultry', 'Pig'],
    supplier:    'stibiotechnologie',
    packSize:    '1 L',
    featured:    false,
    flagship:    false,
    image:       metalac,
    tagline:     'Postbiotic gut health via essential oils.',
    description: 'Metalac is a postbiotic supplement combining essential oils to improve gut health in poultry and pigs. By leveraging the power of postbiotics and essential oils, Metalac supports a balanced gut microbiome, enhances nutrient absorption, and promotes overall digestive well-being.',
    benefits: [
      'Improves gut health via essential oils',
      'Postbiotic support for gut microbiome balance',
      'Enhances nutrient absorption',
      'Suitable for poultry and pigs',
      'Natural essential oil formulation',
    ],
    usage: 'Administer via drinking water or feed as directed. Consult technical team for dosage.',
  },

    // ── POULTRY - TEX BIOSCIENCES ────────────────────────────────────────────

  {
    id:          'lipotex-plus',
    slug:        'lipotex-plus',
    name:        'Lipotex Plus',
    badge:       'Feed Additive',
    category:    'feed-additives',
    sectors:     ['Poultry'],
    supplier:    'texbiosciences',
    packSize:    '25 Kg',
    featured:    false,
    flagship:    false,
    image:       lipotexplus,
    tagline:     'Better fat utilisation in the feed.',
    description: 'Lipotex Plus is a feed emulsifier that improves the utilisation of fats and oils in poultry diets. By enhancing fat emulsification, it increases the energy value of the feed, improves feed conversion ratio, and allows for better use of dietary fat - resulting in improved growth performance and reduced feed costs.',
    benefits: [
      'Feed emulsification for better use of fat in the feed',
      'Increases available energy from feed',
      'Improves feed conversion ratio',
      'Reduces feed cost per kg of gain',
      'Supports broiler growth performance',
    ],
    usage: 'Mix homogeneously into complete feed. Consult technical team for inclusion rate.',
  },

  {
    id:          'tex-phytase',
    slug:        'tex-phytase',
    name:        'Tex Phytase',
    badge:       'Feed Additive',
    category:    'feed-additives',
    sectors:     ['Poultry'],
    supplier:    'texbiosciences',
    packSize:    '25 Kg',
    featured:    false,
    flagship:    false,
    image:       texphytase,
    tagline:     'Unlock plant phosphorus in poultry feed.',
    description: 'Tex Phytase is a phytase enzyme that unlocks phosphorus bound in plant-based feed ingredients. Poultry cannot naturally digest phytate phosphorus - Tex Phytase breaks it down into a bioavailable form, reducing the need for inorganic phosphate supplementation and improving environmental sustainability.',
    benefits: [
      'Better use of plant-based phosphorous',
      'Releases plant-bound phosphorus',
      'Reduces need for inorganic phosphate',
      'Improves bone mineralisation',
      'Lowers feed formulation cost',
    ],
    usage: 'Incorporate into complete feed at point of mixing. Thermal stable formulation.',
  },

  // ── POULTRY - OMEGA PHARMA ────────────────────────────────────────────────

  {
    id:          'all-lyte-c',
    slug:        'all-lyte-c',
    name:        'All-Lyte C',
    badge:       'Electrolyte',
    category:    'electrolytes',
    sectors:     ['Poultry'],
    supplier:    'omegapharma',
    packSize:    '1 Kg',
    featured:    true,
    flagship:    true,
    image:       alllytec,
    tagline:     'Electrolyte balance for heat stress recovery.',
    description: 'All-Lyte C is an electrolyte supplement formulated to restore electrolyte balance and support recovery from heat stress in poultry. Heat stress causes significant loss of key electrolytes - All-Lyte C provides rapid replenishment to maintain performance and reduce mortality.',
    benefits: [
      'Heat stress management via electrolyte balance',
      'Rapid electrolyte replenishment',
      'Restores water and ion balance',
      'Reduces heat stress mortality',
      'Supports recovery and productivity',
    ],
    usage: 'Dissolve in drinking water during and after heat stress events.',
  },

]

// ── Helper functions ──────────────────────────────────────────────────────────

export const getFeaturedProducts = () =>
  products.filter(p => p.featured)

export const getFlagshipProducts = () =>
  products.filter(p => p.flagship)

export const getProductBySlug = (slug) =>
  products.find(p => p.slug === slug) || null

export const getProductsByCategory = (categoryId) =>
  products.filter(p => p.category === categoryId)

export const getProductsBySector = (sectorId) =>
  products.filter(p =>
    p.sectors.map(s => s.toLowerCase()).includes(sectorId.toLowerCase())
  )

export const getProductsBySupplier = (supplierId) =>
  products.filter(p => p.supplier === supplierId)

export const getAllProductCategories = () =>
  [...new Set(products.map(p => p.category))]

export default products